import { memo } from 'react';

import AppModal from '../../../components/AppModal';

import CreateTagForm from './CreateTagForm';

function AddTagModal({
  formRef,
  isOpen,
  submittable,
  onSubmit,
  onCancel,
  farm_opts,
  onChange,
  setCreateFormSubmittable
}) {
  return (
    <AppModal
      confirmButtonText="Add tag"
      title="Add Kraal Tag"
      confirmButtonDisabled={!submittable}
      isOpen={isOpen}
      handleCancel={onCancel}
      handleConfirm={onSubmit}>
      <CreateTagForm
        className="py-4"
        formRef={formRef}
        farm_opts={farm_opts}
        onChange={onChange}
        setSubmittable={setCreateFormSubmittable}
      />
    </AppModal>
  );
}

export default memo(AddTagModal);
